import { Button, ButtonProps } from "@mui/material";

interface CardButtonProps extends Omit<ButtonProps, "variant" | "color"> {
  children: React.ReactNode;
  height?: number;
  variant?: "filled" | "outlined";
}

export const CardButton = ({
  children,
  disabled,
  onClick,
  fullWidth = true,
  height,
  variant = "filled",
  sx,
  ...props
}: CardButtonProps) => {
  return (
    <Button
      variant={variant === "filled" ? "card" : "outlined"}
      color="primary"
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      sx={{
        ...(height && { height }),
        ...(!fullWidth && { whiteSpace: "nowrap" }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
